module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-5",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("CHAPTER IV.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("the shadow of the englishmen")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Now I will pass on to the time when Ralph was nineteen or thereabouts, and save for the lack of hair upon his face, a man grown, since in our climate young people ripen quickly in body if not in mind. I tell of that year with shame and sorrow, for it was then that Jan and I committed a great sin, for which afterwards we were punished heavily enough.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("At the beginning of winter Jan trekked to the nearest dorp, some fifty miles away, with a waggon load of mealies and of buckskins which he and Ralph had shot, purposing to sell them and to attend the Nachtmahl, or Feast of the Lord’s Supper. I was somewhat ailing just then and did not accompany him, nor did Suzanne, who stayed to nurse me, or Ralph, who was left to look after us both.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Fourteen days later Jan returned, and from his face I saw at once that something had gone wrong.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“What is it, husband?” I asked. “Did not the mealies sell well?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, yes, they sold well,” he answered, “for that fool of an English storekeeper bought them and the hides together for more than their value.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Are the Kaffirs going to rise again, then?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“No, they are quiet for the present, though the accursed missionaries of the London Society are doing their best to stir them up,” and he made a sign to me to cease from asking questions, nor did I say any more till we had gone to bed and everybody else in the house was asleep.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Now,” I said, “tell me your bad news, for bad news you have had.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Wife,” he answered, “it is this. In the dorp yonder I met a man who had come from Port Elizabeth. He told me that there at the port were two Englishmen, who had recently arrived, a Scotch lord, and a lawyer with red hair. When the Englishmen heard that he was from this part of the country they fell into talk with him, saying that they came upon a strange errand. It seems that when the great ship was wrecked upon this coast ten years ago there was lost in her a certain little boy who, if he had lived, would to-day have been a very rich noble in Scotland. Wife, you may know who that little boy was without my telling you his name.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("I nodded and turned cold all over my body, for I could guess what was coming.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Now for a long while those who were interested in him supposed that this lad was certainly dead with all the others on board that ship, but a year or more ago, how I know not, a rumour reached them that one male child who answered to his description had been saved alive and adopted by some boers living in the Transkei. By this time the property and the title that should be his had descended to a cousin of the child’s, but this relation being a just man determined before he took them to come to Africa and find out the truth for himself, and there he is at Port Elizabeth, or rather by this time he is on his road to our place. Therefore it would seem that the day is at hand when we shall see the last of Ralph.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Never!” I said, “he is a son to us and more than a son, and I will not give him up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Then they will take him, wife. Yes, even if he does not wish it, for he is a minor and they are armed with authority.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Oh!” I cried, “it would break my heart, and, Jan, there is another heart that would break also,” and I pointed towards the chamber where Suzanne slept.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He nodded, for none could live with them and not know that this youth and maiden loved each other dearly.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“It would break your heart,” he answered, “and her heart; yes, and my own would be none the better for the wrench; yet how can we turn this evil from our door?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Jan,” I said, “the winter is at hand; it is time that you and Ralph should take the cattle to the bush-veldt yonder, where they will lie warm and grow fat, for so large a herd cannot be trusted to the Kaffirs. Had you not better start to-morrow? If these English meddlers should come here I will talk with them. Did Suzanne save the boy for them? Did we rear him for them, although he was English? Think how you will feel when he has crossed the ridge yonder for the last time, you who are sonless, and you must go about your tasks alone, must ride alone and hunt alone, and, if need be, fight alone, except for his memory. Think, Jan, think.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Do not tempt me, woman,” he whispered back in a hoarse voice, for Ralph and he were more to each other than any father and son that I have known, since they were also the dearest of friends. “Do not tempt me,” he went on; “the lad must himself be told of this, and he must judge; he is young, but among us at nineteen a youth is a burgher grown, with a right to take up land and marry. He must be told, I say, and at once.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“It is good,” I said, “let him judge;” but in the wickedness of my heart I made up my mind that I would find means to help his judgment, for the thought of losing him filled me with blind terror, and all that night I lay awake thinking out the matter.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Early in the morning I rose and went to the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("stoep")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(", where I found Suzanne drinking coffee and singing a little song that Ralph had taught her. I can see her now as she stood in her pretty tight-fitting dress, a flower wet with dew in her girdle, swinging her ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("kapje")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" by its strings while the first rays of the sun glistened on the waves of her brown and silk-like hair. She was near eighteen then, and so beautiful that my heart beat with pride at her loveliness, for never in my long life have I seen a girl of any nation who could compare with my daughter Suzanne in looks. Many women are sweet to behold in this way or in that; but Suzanne was beautiful every way, yes, and at all ages of her life; as a child, as a maiden, as a matron and as a woman drawing near to eld, she was always beautiful if, like that of the different seasons, her beauty varied. In shape she was straight and tall and rounded, light-footed as a buck, delicate in limb, wide-breasted and slender-necked. Her face was rich in hue as a kloof lily, and her eyes—ah! no antelope ever had eyes darker, tenderer, or more appealing than were the eyes of Suzanne. Moreover, she was sweet of nature, ready of wit and good-hearted—yes, even for the Kaffirs she had a smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“You are up betimes, Suzanne,” I said when I had looked at her a little.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, mother; I rose to make Ralph his coffee, he does not like that the Kaffir women should boil it for him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“You mean that you do not like it,” I answered, for I knew that Ralph thought little of who made the coffee that he drank, or if he did it was mine that he held to be the best, and not Suzanne’s, who in those days was a careless girl, thinking less of household matters than she should have done.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Did Swart Piet come here yesterday?” I asked. “I thought that I saw his horse as I walked back from the sea.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, he came.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“What for?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She shrugged her shoulders. “Oh! mother, why do you ask me? You know well that he is always troubling me, bringing me presents of flowers, and asking me to ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("opsit")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" with him and what not.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Then you don’t want to ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("opsit")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" with him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“The candle would be short that I should burn with Swart Piet,” answered Suzanne, stamping her foot; “he is an evil man, full of dark words and ways, and I fear him, for I think that since his father’s death he has become worse, and the most of the company he keeps is with those Kaffir witch-doctors.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Ah! like father, like son. The mantle of Elijah has fallen upon Elisha, but inside out. Well, it is what I expected, for sin and wizardry were born in his blood. Had you any words with him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, some. I would not listen to his sweet talk, so he grew angry and began to threaten; but just then Ralph came back and he went away, for he is afraid of Ralph.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Where has Ralph gone so early?” I asked, changing the subject.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“To the far cattle-kraal to look after the oxen which the Kaffir bargained to break into the yoke. They are choosing them this morning.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“So. He makes a good Boer for one of English blood, does he not? And yet I suppose that when he becomes English again he will soon forget that he was ever a Boer.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“When he becomes English again, mother! What do you mean by that saying?” she asked quickly.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I mean that like will to like, and blood to blood; also that there may be a nest far away which this bird that we have caged should fill.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“A nest far away, mother? Then there is one here which would be left empty; in your heart and father’s, I mean;” and dropping her sun-bonnet she turned pale and pressed her hands upon her own, adding, “Oh! speak straight words to me. What do you mean by these hints?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I mean, Suzanne, that it is not well for any of us to let our love wrap itself too closely about a stranger. Ralph is an Englishman, not a Boer. He names me mother and your father, father; and you he names sister, but to us he is neither son nor brother. Well, a day may come when he learns to understand this, when he learns to understand also that he has other kindred, true kindred far away across the sea; and if those birds call, who will keep him in the strange nest?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Ah!” she echoed, all dismayed, “who will keep him then?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“I do not know,” I answered; “not a foster father or mother. But I forgot. Say, did he take his rifle with him to the kraal?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Surely, I saw it in his hand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Then, daughter, if you will, get on a horse, and if you can find Ralph, tell him that I shall be very glad if he can shoot a small buck and bring it back with him, as I need fresh meat.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“May I stay with him while he shoots the buck, mother?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, if you are not in his way and do not stop too long.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Then, without more words, Suzanne left me, and presently I saw her cantering across the veldt upon her grey mare that Ralph had broken for her, and wondered if she would find him and what luck he would have with the hunt that day.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Now it seems that Suzanne found Ralph and gave him my message, and that they started together to look for buck on the strip of land which lies between the seashore and the foot of the hills, where sometimes the blesbok and springbok used to feed in thousands. But on this day there were none to be seen, for the dry grass had already been burnt off, so that there was nothing for them to eat.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“If mother is to get her meat to-day,” said Ralph at length, “I think that we must try the hill side for a duiker or a bush-buck.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("So they turned inland and rode towards that very kloof where years before Suzanne had discovered the shipwrecked boy. At the mouth of this kloof was a patch of marshy ground, where the reeds still stood thick, since being full of sap they had resisted the fire.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“That is a good place for a riet-buck,” said Ralph, “if only one could beat him out of it, for the reeds are too tall to see to shoot in them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“It can be managed,” answered Suzanne. “Do you go and stand in the neck of the kloof while I ride through the reeds towards you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“You might get bogged,” he said doubtfully.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“No, no, brother; after all this drought the pan is nothing more than spongy, and if I should get into a soft spot I will call out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("To this plan Ralph at length agreed, and having ridden round the pan, which was not more than fifty yards across, he dismounted from his horse and hid himself behind a bush in the neck of the kloof. Then Suzanne rode in among the reeds, shouting and singing, and beating them with her sjambock in order to disturb anything that might be hidden there. Nor was her trouble in vain, for suddenly, with a shrill whistle of alarm by the sound of which this kind of antelope may be known even in the dark, up sprang two riet-buck and dashed away towards the neck of the kloof, looking large as donkeys and red as lions as they vanished into the thick cover. So close were they to Suzanne that her mare took fright and reared; but the girl was the best horsewoman in those parts, and kept her seat, calling the while to Ralph to make ready for the buck. Presently she heard a shot, and having quieted the mare, rode out of the reeds and galloped round the dry pan to find Ralph looking foolish with no riet-buck in sight.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Have you missed them?” she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“No, not so bad as that, for they passed within ten yards of me, but the old gun hung fire. I suppose that the powder in the pan was a little damp, and instead of hitting the buck in front I caught him somewhere behind. He fell down, but has gone on again, so we must follow him, for I don’t think that he will get very far.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Accordingly, when Ralph had reloaded his gun, which took some time—for in those days we had scarcely anything but flintlocks—yes, it was with weapons like these that a handful of us beat the hosts of Dingaan and Moselikatse—they started to follow the blood spoor up the kloof, which was not difficult, as the animal had bled much. Near to the top of the kloof the trail led them through a thick clump of mimosas, and there in the dell beyond they found the riet-buck lying dead. Riding to it they dismounted and examined it.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Poor beast,” said Suzanne; “look how the tears have run down its face. Well, I am glad that it is dead and done with,” and she sighed and turned away, for Suzanne was a silly and tender-hearted girl who never could understand that the animals—yes, and the heathen Kaffirs, too—were given to us by the Lord for our use and comfort.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Presently she started and said, “Ralph, do you remember this place?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He glanced round and shook his head, for he was wondering whether he would be able to lift the buck on to the horse without asking Suzanne to help him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Look again,” she said; “look at that flat stone and the mimosa tree lying on its side near it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Ralph dropped the leg of the buck and obeyed her, for he would always do as Suzanne bade him, and this time it was his turn to start.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Almighty!” he said, “I remember now. It was here that you found me, Suzanne, after I was shipwrecked, and the tigers stared at us through the boughs of that fallen tree,” and he shivered a little, for the sight of the spot brought back to his heart some of the old terrors which had haunted his childhood.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Yes, Ralph, it was here that I found you. I heard the sound of your voice as you knelt praying on this stone, and I followed it. God heard that prayer, Ralph.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“And sent an angel to save me in the shape of a little maid,” he answered; adding, “Don’t blush so red, dear, for it is true that ever since that day, whenever I think of angels, I think of you; and whenever I think of you I think of angels, which shows that you and the angels must be close together.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Which shows that you are a wicked and silly lad to talk thus to a Boer girl,” she answered, turning away with a smile on her lips and tears in her eyes, for his words had pleased her mind and touched her heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("He looked at her, and she seemed so sweet and beautiful as she stood thus, smiling and weeping together as the sun shines through summer rain, that, so he told me afterwards, something stirred in his breast, something soft and strong and new, which caused him to feel as though of a sudden he had left his boyhood behind him and become a man, aye, and as though this fresh-faced manhood sought but one thing more from Heaven to make it perfect, the living love of the fair maiden who until this hour had been his sister in heart though not in blood.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“Suzanne,” he said in a changed voice, “the horses are tired; let them rest, and let us sit upon this stone and talk a little, for though we have never visited it for many years the place is lucky for you and me since it was here that our lives first came together.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Now although Suzanne knew that the horses were not tired she did not think it needful to say him nay.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38d58ef7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled839.vue
// module id = 78
// module chunks = 0